// Module
var code = "<h1 id=\"ways-to-pay\">Ways to Pay</h1> ";
// Exports
export default code;